import type { MeterReadingType } from "../lib/types";
import { Button } from "./button";

type UtilityTypeTabsProps = {
  activeType: MeterReadingType;
  onChange: (type: MeterReadingType) => void;
  electricityLabel: string;
  waterLabel: string;
};

export const UtilityTypeTabs = ({
  activeType,
  onChange,
  electricityLabel,
  waterLabel,
}: UtilityTypeTabsProps) => (
  <div className="flex flex-wrap gap-2">
    <Button
      variant={activeType === "electricity" ? "default" : "outline"}
      onClick={() => onChange("electricity")}
    >
      {electricityLabel}
    </Button>
    <Button
      variant={activeType === "water" ? "default" : "outline"}
      onClick={() => onChange("water")}
    >
      {waterLabel}
    </Button>
  </div>
);
